import { render, staticRenderFns } from "./AppSideBar.vue?vue&type=template&id=610e3545"
import script from "./AppSideBar.vue?vue&type=script&lang=js"
export * from "./AppSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports